// API-Konfiguration
// Lade die API-URL aus Umgebungsvariablen oder verwende Standardwert

const getApiBaseUrl = () => {
  // In Entwicklung: Prüfe Vite-Umgebungsvariable
  // Setze VITE_API_BASE_URL in deiner .env-Datei
  // Beispiel: VITE_API_BASE_URL=https://deine-domain.de/api
  if (import.meta.env.VITE_API_BASE_URL) {
    const url = import.meta.env.VITE_API_BASE_URL
    // Entferne trailing slash falls vorhanden
    return url.endsWith('/') ? url.slice(0, -1) : url
  }
  
  // Fallback: Relativer Pfad (für lokale Entwicklung)
  return '/api'
}

export const API_BASE_URL = getApiBaseUrl()

/**
 * Liefert die URL für Event- und Brunch-Bilder (Flyer/Vorschau).
 * Bilder aus event_flyer werden über die API ausgeliefert (PHP liest aus public/event_flyer/),
 * damit sie unabhängig von der Document-Root des Servers funktionieren.
 */
export function getEventImageUrl(path: string | null | undefined): string {
  if (!path || path.trim() === '') return ''
  const trimmed = path.trim()
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed
  // Neue Uploads: über API ausliefern (PHP liest aus public/event_flyer/, unabhängig von Document Root)
  if (trimmed.startsWith('/event_flyer/')) {
    const filename = trimmed.slice('/event_flyer/'.length).replace(/^.*\//, '') // nur Dateiname
    if (filename) {
      const apiBase = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL
      return `${apiBase}/serve_event_flyer?file=${encodeURIComponent(filename)}`
    }
  }
  if (trimmed.startsWith('/assets/flyer/')) return trimmed
  // Alte Event-Bilder: /flyer/ → /assets/flyer/ (Server-Struktur)
  if (trimmed.startsWith('/flyer/')) {
    const filename = trimmed.slice('/flyer/'.length)
    return `/assets/flyer/${filename}`
  }
  // /brunch/ und andere absolute Pfade unverändert
  return trimmed.startsWith('/') ? trimmed : '/' + trimmed
}

/** Fallback-Bild bei Ladefehler (liegt im Root-/flyer/-Ordner auf dem Server). */
export const EVENT_IMAGE_FALLBACK = '/flyer/scheunennacht.jpg'

/**
 * Session ungültig: Token und User löschen, sofort zur Login-Seite.
 * Wird bei 401 oder expliziter Session-Invalidierung aufgerufen.
 */
export function clearSessionAndRedirectToLogin(): void {
  localStorage.removeItem('dashboard_token')
  localStorage.removeItem('dashboard_user')
  window.location.href = '/dashboard/login'
}

// Helper-Funktion für API-Calls
export const apiFetch = async (endpoint: string, options: RequestInit = {}) => {
  let url: string
  
  // Wenn Endpoint bereits vollständige URL ist, verwende sie direkt
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    url = endpoint
  } 
  // Wenn API_BASE_URL vollständige URL ist (externe URL)
  else if (API_BASE_URL.startsWith('http://') || API_BASE_URL.startsWith('https://')) {
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : '/' + endpoint
    url = `${API_BASE_URL}${cleanEndpoint}`
  }
  // Relativer Pfad (für lokale Entwicklung)
  else {
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : '/' + endpoint
    url = `${API_BASE_URL}${cleanEndpoint}`
  }
  
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

  // Bei 401 (ungültige/abgelaufene Session): sofort ausloggen und zur Login-Seite
  if (response.status === 401 && !url.includes('/auth/login')) {
    if (localStorage.getItem('dashboard_token')) {
      clearSessionAndRedirectToLogin()
    }
    return response
  }

  return response
}

